export const BUSINESS_DETAILS = {
    businessFullName: 'Kritajna Homes',
    businessShortName: 'Kritajna Homes',
    mail: 'hello@kritajnahomes.com',
    phoneNumber: '+91 89515 32497',
    openingHours: '09:00 to 20:00',
    address: {
        sector: 'MURADNAGAR',
        siteName: 'Nearby Kiet GROUP OF INSTITUTIONS',
        placeName: 'GHAZIABAD',
        cityName: 'GHAZIABAD',
        state: 'y',
        pinCode: '201206',
        url: "",
        location: 'Nearby Kiet GROUP OF INSTITUTIONS,MURADNAGAR GHAZIABAD,201206',
        locations: ["Nearby Kiet GROUP OF INSTITUTIONS,MURADNAGAR GHAZIABAD,201206", "Bairasandra, B.C Gundappa Layout, Byrasandra, C V Raman Nagar, Bengaluru, Karnataka 560093", "119, khandagiri, bhubneswar, 751030"],
        fullAddress: 'Nearby Kiet GROUP OF INSTITUTIONS,MURADNAGAR GHAZIABAD,201206',
    },
    owner: {
        name: 'Owner Name',
        experience: 15,
        projects: 125
    }
}

export const SOCIAL_MEDIA_LINKS = [
    {
        icon: 'instagram',
        href: ''
    },
    {
        icon: 'facebook',
        href: ''
    },
    {
        icon: 'whatsapp',
        href: ''
    },
];
